module.exports = __webpack_public_path__ + "assets/map-cluster.png?1282189e21e2d8bb3628d7a9acca4243";